var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled, { spacing } from "@rentiohq/web-theme";
export var Form = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-right: ", ";\n  margin-bottom: ", ";\n"], ["\n  margin-right: ", ";\n  margin-bottom: ", ";\n"])), spacing(), spacing());
var templateObject_1;
